var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"pb-6",attrs:{"type":""}},[_c('div',{staticClass:"row align-items-center"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }